export enum MenuItems {
  DASHBOARD_MODULE = 'DASHBOARD_MODULE',
  CATALOGUE_MODULE = 'CATALOGUE_MODULE',
  CUSTOMERS = 'CUSTOMERS',
  PARTNERS = 'PARTNERS',
  LEADS = 'LEADS',
  OPERATIONS = 'OPERATIONS',
  // PAYMENTS_MODULE = 'PAYMENTS_MODULE',
  PRODUCTS = 'PRODUCTS',
  REPORTS = 'REPORTS',
  USERS = 'USERS',
  SALES = 'SALES',
  COMMUNICATION = 'COMMUNICATION',
  SETTINGS = 'SETTINGS',
  ATTENDANCE = 'ATTENDANCE',
  REQUESTS = 'REQUESTS',
  HR = 'HR',
  HELPDESK = 'HELPDESK',
  SIMULATORS = 'SIMULATORS'
}
